import React, { Component } from "react";
import { Button, Card, Drawer, Input, Select, Space, message } from "antd";
import { LinkOutlined } from "@ant-design/icons";
import { MessageBox } from "react-chat-elements";
import moment from "moment";
import countries from "../utils/countries.json";
import { assistant } from "../../../utils/axios/assistant";
const { Option } = Select;

class NewChatModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      allTemplates: [],
      filteredTemplates: [],
      selectedMessage: null,
      renderedMessage: null,
      variables: null,
      buttonsVariables: null,
      employee: null,
      loading: false,
      department: null,
      customerPhone: null,
      selectedCountry: "+34",
    };
    this.handleOk = this.handleOk.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSelectChange = this.handleSelectChange.bind(this);
    this.handleButtonInputChange = this.handleButtonInputChange.bind(this);
  }

  async componentDidMount() {
    try {
      const { employee } = this.props;
      const employee_name = employee.name.split("-")[0];
      // const res = await assistant.get(`/templates`);
      this.setState({
        // allTemplates: res.data,
        // filteredTemplates: res.data,
        employee: employee_name,
      });
    } catch (error) {
      console.error(error);
      message.error("Ha ocurrido un error al cargar los mensajes.");
    }
  }

  componentDidUpdate(prevProps) {
    const { templates } = this.props;
    if (prevProps.templates !== templates) {
      this.setState({ allTemplates: templates, filteredTemplates: templates });
    }
  }

  handleOk = async () => {
    this.setState({ loading: true });
    try {
      const {
        allTemplates,
        selectedMessage,
        variables,
        renderedMessage,
        customerPhone,
        buttonsVariables,
        selectedCountry,
      } = this.state;

      const body = Object.keys(variables).map((vari) => ({
        type: "text",
        parameter_name: vari,
        text: variables[vari],
      }));

      const buttons = Object.entries(buttonsVariables || {}).map(
        ([key, value]) => ({
          text: value,
          type: "text",
        })
      );

      const data = { body, buttons: buttons.length > 0 ? buttons : undefined };

      await assistant.post(`/send-message`, {
        client_phone: selectedCountry + customerPhone.replace(/\s+/g, ""),
        employee_id: this.props.employee.uuid,
        conversation_id: "",
        message: {
          type: "template",
          template_key: selectedMessage.meta_name,
          data,
          fullMessage: renderedMessage,
        },
      });
      message.success("Mensaje enviado exitosamente.");
      this.props.handleClose();
      this.setState({
        filteredTemplates: allTemplates,
        selectedMessage: null,
        renderedMessage: null,
        variables: null,
        employee: null,
        loading: false,
        department: null,
        customerPhone: null,
      });
    } catch (error) {
      message.error("Ha ocurrido un error al enviar el mensaje.");
    } finally {
      this.setState({ loading: false });
    }
  };

  handleValidation() {
    const { variables, department, customerPhone, selectedMessage } =
      this.state;
    if (!customerPhone || !department || !selectedMessage) {
      return true;
    }

    const validation = Object.values(variables).filter(
      (value) => value.trim().length === 0
    );
    if (validation.length > 0) {
      return true;
    }

    return false;
  }

  handleDepartmentSelect(selectedDepartment) {
    const { allTemplates } = this.state;
    const filteredTemplates = allTemplates.filter((template) =>
      template.departments.some(
        (department) => department.slug === selectedDepartment
      )
    );
    this.setState({
      filteredTemplates,
      department: selectedDepartment,
      selectedMessage: null,
    });
  }

  handleSelectChange(message_id) {
    const { filteredTemplates, employee } = this.state;
    const selectedMessage = filteredTemplates.find(
      (message) => message.id === message_id
    );
    selectedMessage.button = selectedMessage.button
      ? JSON.parse(selectedMessage.button)
      : null;

    const regex = /{{(.*?)}}/g;
    let match;
    const variables = {};
    while ((match = regex.exec(selectedMessage.message)) !== null) {
      variables[match[1].trim()] =
        match[1].trim() === "nombre_operador" ? employee : "";
    }

    const newRenderMessage = selectedMessage.message.replace(
      /{{(.*?)}}/g,
      (value, key) => {
        return key.trim() in variables && variables[key.trim()].length > 0
          ? variables[key.trim()]
          : value;
      }
    );
    const buttonsVariables = selectedMessage.button
      ? selectedMessage.button.reduce((acc, btn) => {
          acc[btn.text] = "";
          return acc;
        }, {})
      : null;

    this.setState({
      selectedMessage,
      variables,
      buttonsVariables,
      renderedMessage: newRenderMessage,
    });
  }

  handleInputChange(event) {
    const { selectedMessage, variables } = this.state;
    const template = selectedMessage.message;
    const newVariables = {
      ...variables,
      [event.target.name]: event.target.value,
    };

    const newRenderMessage = template.replace(/{{(.*?)}}/g, (value, key) => {
      return key.trim() in newVariables && newVariables[key.trim()].length > 0
        ? newVariables[key.trim()]
        : value;
    });

    this.setState({
      renderedMessage: newRenderMessage,
      variables: newVariables,
    });
  }

  handleButtonInputChange(event) {
    const { buttonsVariables } = this.state;
    const newButtonVariables = {
      ...buttonsVariables,
      [event.target.name]: event.target.value,
    };

    this.setState({ buttonsVariables: newButtonVariables });
  }

  render() {
    const { openModal, handleClose, dateFormatter } = this.props;
    const {
      filteredTemplates,
      selectedMessage,
      renderedMessage,
      variables,
      buttonsVariables,
      department,
      customerPhone,
      selectedCountry,
    } = this.state;

    return (
      <Drawer
        title={"Crear chat"}
        closeIcon={false}
        open={openModal}
        width={500}
      >
        <div>
          <label style={{ margin: 2 }}>Móvil:</label>
          <Input
            addonBefore={
              <Select
                placeholder="Selecciona un país"
                onChange={({ value }) =>
                  this.setState({ selectedCountry: value })
                }
                value={selectedCountry}
                labelInValue
              >
                {countries.map((country) => (
                  <Option key={country.value} value={country.value}>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <span
                        dangerouslySetInnerHTML={{ __html: country.label }}
                      />
                      <span style={{ marginLeft: 8 }}>{country.name}</span>
                    </div>
                  </Option>
                ))}
              </Select>
            }
            placeholder="777 777 777"
            value={customerPhone}
            onChange={(event) => {
              let inputValue = event.target.value.replace(/\s+/g, "");
              if (inputValue.length <= 15 && !isNaN(inputValue)) {
                inputValue = inputValue.replace(/(\d{3})(?=\d)/g, "$1 ").trim();
                this.setState({ customerPhone: inputValue });
              }
            }}
          />
        </div>
        <div>
          <label style={{ margin: 2 }}>Departamento:</label>
          <Select
            style={{ width: "100%" }}
            value={department}
            onChange={(value) => this.handleDepartmentSelect(value)}
          >
            {/* <Select.Option value="welcome">Recepción</Select.Option> */}
            <Select.Option value="commercial">Comercial</Select.Option>
            <Select.Option value="billing">Facturación</Select.Option>
            <Select.Option value="technician">Soporte técnico</Select.Option>
          </Select>
        </div>
        <div>
          <label style={{ margin: 2 }}>Mensaje:</label>
          <Select
            disabled={!department}
            value={selectedMessage && selectedMessage.id}
            style={{ width: "100%" }}
            onChange={this.handleSelectChange}
            // options={filteredTemplates.map((elem) => ({
            //   label: elem.public_name,
            //   value: elem.id,
            //   disabled: true
            // }))}
          >
            {filteredTemplates &&
              filteredTemplates.map((opt) => (
                <Option
                  disabled={opt.visibility === "disable"}
                  key={opt.id}
                  value={opt.id}
                >
                  {opt.public_name}
                </Option>
              ))}
          </Select>
        </div>
        {selectedMessage && (
          <div
            style={{
              marginTop: 20,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              gap: 10,
            }}
          >
            <Card style={{ width: "100%" }}>
              <MessageBox
                position="right"
                title="Nadunet"
                type="text"
                text={renderedMessage.split("\n").map((line, i) => (
                  <span key={i}>
                    {line}
                    <br />
                  </span>
                ))}
                dateString={dateFormatter(moment().unix())}
                className="message-container nadunetText2"
              />
            </Card>
            {variables && (
              <Card style={{ width: "100%" }}>
                <p style={{ margin: 0, fontWeight: "bold" }}>
                  Variables del mensaje
                </p>
                {Object.keys(variables).map((variable) => (
                  <div key={variable}>
                    <label style={{ margin: 4 }}>
                      {variable
                        .split("_")
                        .map(
                          (word) => word.charAt(0).toUpperCase() + word.slice(1)
                        )
                        .join(" ") + ":"}
                    </label>
                    <Input
                      name={variable}
                      value={variables[variable]}
                      onChange={this.handleInputChange}
                    />
                  </div>
                ))}
              </Card>
            )}
            {selectedMessage.button && (
              <Card style={{ width: "100%" }}>
                <p style={{ margin: 0, fontWeight: "bold" }}>Botones</p>
                {selectedMessage.button.map((btn, idx) => (
                  <div key={idx}>
                    <label style={{ margin: 4 }}>
                      {btn.type === "URL" && <LinkOutlined />} {btn.text}
                    </label>
                    <Input
                      addonBefore="https://ndnt.es/"
                      name={btn.text}
                      value={buttonsVariables[btn.text]}
                      onChange={this.handleButtonInputChange}
                    />
                  </div>
                ))}
              </Card>
            )}
          </div>
        )}
        <Space style={{ marginTop: 20 }}>
          <Button onClick={handleClose}>Cancelar</Button>
          <Button
            type="primary"
            onClick={this.handleOk}
            loading={this.state.loading}
            disabled={this.handleValidation()}
          >
            Enviar
          </Button>
        </Space>
      </Drawer>
    );
  }
}

export default NewChatModal;



// WEBPACK FOOTER //
// ./src/views/NaduChat/components/NewChatModal.jsx